module.exports = __webpack_public_path__ + "static/media/favicon.2d963962.png";